/**
 * AdjustmentsPrint — page annexe « Ajustements ».
 * Réutilise la PAGE RÉELLE de l'écran (AdjustmentsPage embedded) : journal plat
 * des écritures manuelles (corrections, reclassements, provisions). Les contrôles
 * d'édition (boutons, colonne suppression, champs) sont aplatis/masqués au print.
 *
 * Sans ajustement sur l'exercice → aucune section rendue (pas de page blanche
 * dans le PDF). On signale malgré tout `onDataReady` pour que le compteur de
 * sous-rapports du document (FinancialsStandardPrint) se complète.
 */
import React, { useEffect, useRef, useState } from 'react';
import AdjustmentsPage from '../AdjustmentsPage';
import { listAdjustments } from '../../api/financials_pl';
import PrintReportHeader from '../hr/print/PrintReportHeader';
import { useP } from '../../i18n/useP';
import '../hr/print/PeoplePrint.css';
import './financialsScreenPrint.css';

const noop = () => {};

export default function AdjustmentsPrint({ activeTenant, year, editedAt, onDataReady }) {
  const p = useP();
  // null = en cours de chargement · [] = aucun · [...] = présents
  const [adjs, setAdjs] = useState(null);
  const done = useRef(false);
  const fire = () => { if (!done.current) { done.current = true; if (onDataReady) onDataReady('financials-adjustments'); } };

  useEffect(() => {
    let alive = true;
    if (!activeTenant?.id) { setAdjs([]); return undefined; }
    listAdjustments(activeTenant.id, year)
      .then(r => { if (alive) setAdjs(r.data || []); })
      .catch(() => { if (alive) setAdjs([]); });
    return () => { alive = false; };
  }, [activeTenant?.id, year]);

  // Aucun ajustement (ou pas de tenant) → on ne rend rien mais on débloque le
  // compteur du document. Le cas « présents » signale via le onReady d'AdjustmentsPage.
  useEffect(() => {
    if (adjs !== null && adjs.length === 0) fire();
  }, [adjs]); // eslint-disable-line

  if (adjs === null || adjs.length === 0) return null;

  return (
    <section className="ppl-print__section ppl-print__section--wide fin-screenprint fin-print-adjustments">
      <PrintReportHeader category={p('Finance · annexe')} title={p('Ajustements')} year={year} tenant={activeTenant} editedAt={editedAt} />
      <AdjustmentsPage embedded activeTenant={activeTenant} year={year} addToast={noop} onReady={fire} />
    </section>
  );
}
